import { useEffect } from 'react'
import { required, SelectInput } from 'react-admin'
import { useWatch, useFormContext } from 'react-hook-form'
import { DepSelectInputProps } from './type'

export const DepSelectInput: React.FC<DepSelectInputProps> = ({
  depField = '',
  expectedValue,
  ...props
}) => {
  const fieldCond = useWatch({ name: depField })
  const { unregister } = useFormContext()

  useEffect(() => {
    if (fieldCond !== expectedValue) {
      unregister(props.source)
    }
  }, [expectedValue, fieldCond, props.source, unregister])
  if (!depField) return null
  const validator = {
    validate: [required()],
  }
  return fieldCond === expectedValue ? (
    <SelectInput {...(fieldCond === expectedValue ? validator : '')} {...props} />
  ) : null
}
